import { PLATFORM } from 'aurelia-pal';
import { ActivitiesListManager } from './services/activitiesList';
import { AppAPI } from './services/appAPI';
import { CustomerAccounts } from './services/customerAccounts';
import { CustomerAccountsListManager } from './services/customerAccountsList';
import { errorParser } from './services/errorParser';
import { ProductFeedsJobsListManager } from './services/productFeedsJobsList';
import { ProductFeedsJobs } from './services/productFeedsJobs';
import { ProductFeedsJobsNotifications } from './services/productFeedsJobsNotifications';
import { Salesforce } from './services/salesforce';

const jobsNotificationsContainer = PLATFORM
.moduleName('./containers/jobsNotifications/jobsNotifications.container');

const inputWithAction = PLATFORM
.moduleName('./components/inputWithAction/inputWithAction');
const jobsList = PLATFORM
.moduleName('./components/jobsList/jobsList');
const listSelector = PLATFORM.moduleName('./components/listSelector/listSelector');
const notificationButton = PLATFORM.moduleName('./components/notificationButton/notificationButton');
const selectionPlaceholder = PLATFORM
.moduleName('./components/selectionPlaceholder/selectionPlaceholder.html');
const sidebarSelector = PLATFORM
.moduleName('./components/sidebarSelector/sidebarSelector');
const simpleTable = PLATFORM
.moduleName('./components/simpleTable/simpleTable');
/**
 * The configuration of the `common` plugin/module.
 * @param {Aurelia} aurelia The application information.
 */
export const configure = (aurelia) => {
  // Services
  aurelia.container.registerSingleton(
    'activitiesListManager',
    ActivitiesListManager,
  );
  aurelia.container.registerSingleton('appAPI', AppAPI);
  aurelia.container.registerSingleton(
    'customerAccounts',
    CustomerAccounts,
  );
  aurelia.container.registerSingleton(
    'customerAccountsListManager',
    CustomerAccountsListManager,
  );
  aurelia.container.registerSingleton(
    'productFeedsJobsListManager',
    ProductFeedsJobsListManager,
  );
  aurelia.container.registerSingleton(
    'productFeedsJobs',
    ProductFeedsJobs,
  );
  aurelia.container.registerSingleton(
    'productFeedsJobsNotifications',
    ProductFeedsJobsNotifications,
  );
  aurelia.container.registerSingleton('salesforce', Salesforce);

  // Components
  aurelia.globalResources(
    jobsNotificationsContainer,
    jobsList,
    inputWithAction,
    listSelector,
    notificationButton,
    selectionPlaceholder,
    sidebarSelector,
    simpleTable,
  );

  // Libraries
  aurelia.container.registerInstance('errorParser', errorParser);
};
